import React from "react";

import { useAdmin } from "context/adminContext";

import AccountDetail from "../partials/accountDetail";

const AccountRemain = () => {
  const { accounts } = useAdmin();

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-4">
        <h2 className="text-lg sm:text-xl font-bold text-gray-900 m-0">
          Дансны үлдэгдлийн тойм
        </h2>
        <p className="text-xs text-gray-500 mt-1 mb-0">
          Дараалал: банкны үлдэгдэл → хүлээгдэж буй queue → зөрүү → өнөөдрийн
          шилжүүлэг (УБ).
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        {accounts &&
          accounts
            .filter((e) => e.type !== "xPay")
            .map((account) => (
              <AccountDetail key={account.accountNumber} account={account} />
            ))}
      </div>
    </div>
  );
};

export default AccountRemain;
